const CONTRACT_TABS = {
  DETAILS: '/details',
  LABOR_CATEGORIES: '/labor-categories',
  ROSTER: '/roster',
  ROSTER_OWNERS: '/roster-owners',
  SETTINGS: '/settings',
} as const;

export const ROUTES = {
  APPROVAL_APPLICATION_DETAILS: '/approvals/application/:id',
  APPROVALS: '/approvals',
  CONTRACT_DETAILS: `/contract/:id${CONTRACT_TABS.DETAILS}`,
  CONTRACT_TABS,
  HOME: '/',
  MANAGE_CONTRACT: '/contract/all',
  MY_PROFILE: '/profile',
  NOVA_APPLICATION: '/application',
  NOVA_APPLICATION_STATUS: '/application/status',
} as const;
